<template>
  <ContentWrap>
    <el-form :model="form" label-width="120px" class="max-w-720px">
      <el-form-item label="统计时间窗" required>
        <el-date-picker
          v-model="range"
          type="datetimerange"
          value-format="YYYY-MM-DD HH:mm:ss"
          start-placeholder="开始(receiveTime)"
          end-placeholder="结束"
          :default-time="[new Date('1 00:00:00'), new Date('1 23:59:59')]"
          class="!w-420px"
        />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.remark" class="!w-420px" />
      </el-form-item>
      <el-form-item>
        <el-button :loading="previewLoading" @click="doPreview">预览分红</el-button>
        <el-button
          v-hasPermi="['distribution:area-agent:settle:create']"
          type="primary"
          :loading="createLoading"
          @click="doCreate"
        >
          创建结算单（立即锁定）
        </el-button>
      </el-form-item>
    </el-form>

    <template v-if="preview">
      <el-descriptions :column="4" border class="mb-16px">
        <el-descriptions-item label="参与折后">￥{{ fenToYuan(preview.goodsAmount || 0) }}</el-descriptions-item>
        <el-descriptions-item label="应发合计">￥{{ fenToYuan(preview.bonusAmount || 0) }}</el-descriptions-item>
        <el-descriptions-item label="订单数">{{ preview.orderCount }}</el-descriptions-item>
        <el-descriptions-item label="代理数">{{ preview.partnerCount }}</el-descriptions-item>
      </el-descriptions>

      <el-divider content-position="left">各层拿满分红</el-divider>
      <el-table :data="preview.layers || []" size="small" class="mb-16px" max-height="280">
        <el-table-column label="订单ID" prop="orderId" width="100" />
        <el-table-column label="userId" prop="userId" width="100" />
        <el-table-column label="类型" width="90">
          <template #default="{ row }">{{ labelOf(AREA_AGENT_TYPE, row.agentType) }}</template>
        </el-table-column>
        <el-table-column label="辖区ID" prop="areaId" width="90" />
        <el-table-column label="费率%" prop="bonusRate" width="80" />
        <el-table-column label="系统额" width="110">
          <template #default="{ row }">￥{{ fenToYuan(row.systemAmount || 0) }}</template>
        </el-table-column>
      </el-table>

      <el-divider content-position="left">订单预览</el-divider>
      <el-table :data="preview.orders || []" size="small" max-height="360">
        <el-table-column label="订单ID" prop="orderId" width="100" />
        <el-table-column label="单号" prop="orderNo" min-width="140" />
        <el-table-column label="参与折后" width="110">
          <template #default="{ row }">￥{{ fenToYuan(row.goodsDiscounted || 0) }}</template>
        </el-table-column>
        <el-table-column label="订单分红" width="110">
          <template #default="{ row }">￥{{ fenToYuan(row.orderBonus || 0) }}</template>
        </el-table-column>
        <el-table-column label="层数" prop="layerCount" width="70" />
      </el-table>
    </template>
  </ContentWrap>
</template>

<script lang="ts" setup>
import { fenToYuan } from '@/utils'
import * as SettleApi from '@/api/mall/trade/areaAgent/settle'
import { AREA_AGENT_TYPE, labelOf } from '../constants'

defineOptions({ name: 'TradeAreaAgentSettleBuild' })

const message = useMessage()
const range = ref<string[]>([])
const form = reactive({ remark: '' })
const previewLoading = ref(false)
const createLoading = ref(false)
const preview = ref<SettleApi.AreaAgentSettlePreviewVO | null>(null)

const buildReq = () => {
  if (!range.value || range.value.length !== 2) {
    message.warning('请选择统计时间窗')
    throw new Error('no range')
  }
  return {
    startTime: range.value[0],
    endTime: range.value[1],
    remark: form.remark
  }
}

const doPreview = async () => {
  try {
    const req = buildReq()
    previewLoading.value = true
    preview.value = await SettleApi.previewAreaAgentSettle(req)
  } catch {
    /* tip already */
  } finally {
    previewLoading.value = false
  }
}

const doCreate = async () => {
  try {
    const req = buildReq()
    await message.confirm('创建后将立即锁定订单并禁售后，是否继续？')
    createLoading.value = true
    const id = await SettleApi.createAreaAgentSettle(req)
    message.success(`已创建结算单 #${id}，请到「待确认」查看`)
    preview.value = null
  } catch {
  } finally {
    createLoading.value = false
  }
}
</script>
